import React from 'react';
import PropTypes from 'prop-types';

const PaymentCards = ({items}) => {
    if (items.length === 0) {
        return null;
    }

    return (
        <span className="payment-cards">
            {items.map(card => <img key={card.name} className="payment-cards-item" src={card.logo} alt={card.name} />)}
        </span>
    );
};

PaymentCards.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        logo: PropTypes.string.isRequired
    })).isRequired
};

export default PaymentCards;
